import React from "react";

export default function FooterSummary() {
  return (
    <div className="mt-10 mb-1 py-3 bg-amber-400 text-white text-center rounded">
      <h2 className="text-lg sm:text-2xl font-semibold">
        Copyright &copy; by Rosa
      </h2>
    </div>
  );
}
